import React from 'react'

import {
    Create,
    required,
    SimpleForm,
    useNotify,
    useRedirect,
    useTranslate,
} from 'react-admin'
import { Typography, useTheme } from '@mui/material';
import NavigateBackBtn from '../../../ui/button/NavigateBackBtn';
import MacAddressFieldsGrid from '../MacAddressFieldsGrid';
import { PickLocationButton } from '../LocationPickerInput';



const validateRequired = [required('Champs obligatoire')]




const MacAddressCreate = () => {
    const translate = useTranslate();
    const theme = useTheme();
    const notify = useNotify();
    const redirect = useRedirect();


    const inputsDataGeneral = [
        { name: 'mac_address', label: translate('resources.mac_addresses.fields.mac_address'), validate: validateRequired, type: "text", fullWidth: true },
        { name: 'latitude', label: translate('resources.mac_addresses.fields.latitude'), validate: validateRequired, type: "number" },
        { name: 'longitude', label: translate('resources.mac_addresses.fields.longitude'), validate: validateRequired, type: "number" },
        { name: 'formatted_address', label: translate('resources.mac_addresses.fields.formatted_address'), validate: validateRequired, type: "text" },
        { name: 'country', label: translate('resources.mac_addresses.fields.country'), type: "text" },
        { name: 'city', label: translate('resources.mac_addresses.fields.city'), type: "text" },
        { name: 'postcode', label: translate('resources.mac_addresses.fields.postcode'), type: "text" },
       
    ]



    const onSuccess = () => {
        notify(translate('resources.mac_addresses.create_success'));
        redirect('/mac_addresses');
    }

    return (
        <>
            <Typography sx={{ color: theme.palette.text.primary, textAlign: 'start', fontWeight: 700, fontSize: "24px", lineHeight: "42px", margin: "0px 0px 16px 0px" }}>
                <NavigateBackBtn /> {translate('resources.mac_addresses.create')}
            </Typography>
            <Create
                redirect="list"
                title={'resources.mac_addresses.create'}
                sx={{
                    "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper,
                        color: theme.palette.text.primary,
                    },
                }}
                mutationOptions={{ onSuccess }}
            >
                <SimpleForm >

                    <Typography color="text.main" sx={{
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontWeight: 700,
                        lineHeight: "25px",
                        textAlign: "center",
                        margin: "0px 0px 10px 0px"
                    }}
                    >
                        {translate('resources.vouchers.sections.general')}
                    </Typography>
                    <MacAddressFieldsGrid inputsData={inputsDataGeneral} />

                    <PickLocationButton
                        latitudeSource="latitude"
                        longitudeSource="longitude"
                        addressSource="formatted_address"
                        countrySource="country"
                        citySource="city"
                        postcodeSource="postcode"
                    />

                </SimpleForm>
            </Create>
        </>
    )
}

export default MacAddressCreate



